import {OptInOuterFrameMrGreenBox} from "./opt-in-outer-frame.mrgreen.box";

export const OptInOuterFrameMrGreenCisBox = OptInOuterFrameMrGreenBox;